import React, { ReactElement } from "react"
import MaskedContainer from "../../MaskedContainer/MaskedContainer";
import Pill from "../../Pill/Pill";
import Chevron from "../../../assets/icons/Chevron.svg";
import ClockIcon from "../../../assets/icons/ClockIcon.svg";
import CalendarIcon from "../../../assets/icons/CalendarIcon.svg";
import { BlogCardProps } from "./BlogCard";
import { Link } from "gatsby";

interface PostType {
    text: string,
}

const Type: React.FC<PostType> = ({ text }): ReactElement => (
    <div className="post-type flex items-center justify-center min-w-[65px] h-[50px] sm:h-[53px] rounded-t-none
        rounded-b-[10px] absolute z-10 right-[20px] bg-bright-cyan px-4">
        <p className="text-white font-ztGraftonRegular text-mobile-subtitle3
        md:text-desktop-subtitle3 uppercase">{text}</p>
        <div className="bg-rich-violet hidden" />
    </div>
);

export interface PostBaseProps extends BlogCardProps {
    type: string,
    children?: JSX.Element[] | JSX.Element,
}

const PostBaseCard: React.FC<PostBaseProps> = ({ title, body, duration, date, type, tag, linkTo='#',
    className = '', children }): ReactElement => (
    <div className={`w-full max-w-[420px] aspect-[1/1.9] min-h-[525px] max-h-[620px] min-w-[310px] bg-black rounded-[20px] 
        relative overflow-hidden [&>div]:h-full ${className}`}>
        <Link to={linkTo}>
            <Type text={type} />
            <div className="post-media h-[55%] w-full flex relative">
                {children}
            </div>
            <div className="absolute bottom-0 z-10 w-full h-[55%]">
                <MaskedContainer bottom={null} className="post-content h-full bg-white pt-10 flex flex-col items-center px-6"
                    top={{image: 'https://atwebsite.blob.core.windows.net/images/bow-top-convex.svg'}}>
                    <div className="text-deep-blue line-clamp-3 subtitle-2-bold text-center pt-4 pb-1 mb-1 overflow-hidden">{title}</div>
                    <div className="flex-grow text-deep-blue line-clamp-3 body text-center max-w-full"
                        style={{maskImage: 'linear-gradient(180deg, #fff 45%, rgba(255,255,255,0.6) 65%, rgba(255,255,255,0.0) 95%)',
                            WebkitMaskImage: 'linear-gradient(180deg, #fff 45%, rgba(255,255,255,0.6) 65%, rgba(255,255,255,0.0) 95%)'}}>{body}</div>
                    <div className="mb-4 mt-6 text-vibrant-green">
                        <div className="flex items-center">
                            <p className="mr-2 font-ibmPlexSansSemiBold text-mobile-button">Read More</p><Chevron />
                        </div>
                    </div>
                    <div className="w-full flex mb-2">
                        <div className="mb-4 flex items-center text-deep-blue">
                            <ClockIcon /><p className="ml-2 font-ibmPlexSansSemiBold text-mobile-subtitle3">{duration}</p>
                        </div>
                        <div className="flex-grow"></div>
                        <div className="mb-4 flex items-center text-deep-blue">
                            <CalendarIcon /><p className="ml-2 font-ibmPlexSansSemiBold text-mobile-subtitle3" suppressHydrationWarning>{date}</p>
                        </div>
                    </div>
                </MaskedContainer>
                <div className="absolute z-10 top-0 flex items-center justify-center w-full">
                    <Pill text={tag} className="post-tag -translate-y-1/4"/>
                </div>
            </div>
        </Link>
    </div>
);

export default PostBaseCard;
